<template>
  <q-dialog
    v-model="dialog"
    style="max-width: 500px"
    persistent
    class="custom-font text-uppercase"
  >
    <q-card class="full-width pragma-black text-white">
        <q-card-section class="q-pa-none text-white">
          <q-toolbar
            class="bg-pragma"
          >
            <span class="text-bold">ADVERTENCIA</span>
            <q-space></q-space>
            <q-btn
              icon="clear"
              flat
              @click="closeDialog()"
            ></q-btn>
          </q-toolbar>
        </q-card-section>
        <q-card-section>
          <p>NO SE PUEDE ASIGNAR EL PROYECTO <strong>{{params.proyecto}}</strong> , A LA SOLICITUD <strong>NRO. {{params.nro}}</strong> , YA QUE EL USUARIO <strong>{{params.usuario}}</strong>  NO ESTA ASIGNADO AL PROYECTO.</p>
          <p>COMUNIQUESE CON EL DEPARTAMENTO DE SISTEMAS PARA GESTIONAR LA ASIGNACION DEL PROYECTO AL USUARIO.</p>
        </q-card-section>
        <q-card-actions>
          <div class="row full-width">
            <div class="col-xs-12">
              <q-btn
                label="Cerrar"
                class="full-width bg-pragma"
                @click="closeDialog()"
              ></q-btn>
            </div>
          </div>
        </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import {ref, inject} from 'vue'

export default {
  setup () {
    // Variables reactivas y no reactivas
    const bus = inject('bus')

    const dialog = ref(false)
    const params = ref({
      proyecto: '',
      nro: 0,
      usuario: ''
    })

    const closeDialog = () => {
      dialog.value = false
    }

    // Creación del componente
    bus.on('openDialogAdvertenciaSolicitud', (item) => {
      params.value = item
      dialog.value = true
    })

    // Retorno de variables al template
    return {
      dialog,
      closeDialog,
      params
    }
  }
}
</script>

<style>

</style>